import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { anmodningStatusColors } from "../libs/mapStyles";

const useStyles = makeStyles((theme) => ({
  pill: {
    display: 'inline-block',
    padding: '4px 12px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: 500,
    textAlign: 'center',
    lineHeight: '1.5',
    whiteSpace: 'nowrap',
  },
}));

/**
 * AnmodningStatusPill component
 * 
 * @param {string} status - The status value (e.g., 'Gennemført', 'Hentet', etc.)
 * @param {object} style - Optional custom styles to override defaults
 */
export default function AnmodningStatusPill({ status, style = {} }) {
  const classes = useStyles();
  
  const isHandledStatus = anmodningStatusColors[status];
  const backgroundColor = isHandledStatus ? anmodningStatusColors[status] : '#757575';
  const text_string = isHandledStatus ? status : 'Kontakt support';
  const textColor = '#ffffff';

  return (
    <span 
      className={classes.pill} 
      style={{ 
        backgroundColor, 
        color: textColor,
        ...style 
      }}
    >
      {text_string}
    </span>
  );
}
